function OurServices() {
    const cards = [
        {
            id: 1,
            Image: "/assests/img/Webdesigning.svg",
            Title: "Web Design & Development",
            content: "Transform your online presence with our expert Web Design & Development solutions, tailored to elevate your brand and engage your audience effectively.",
        },
        {
            id: 2,
            Image: "/assests/img/Mobiledevelopment.svg",
            Title: "Mobile Application",
            content: "Smartphone's are being used on a regular basis and most of the users engaged on smart phones. To elevate your business presence.",
        },
        {
            id: 3,
            Image: "/assests/img/E-Commerce.svg",
            Title: "E-commerce",
            content: "E-commerce revolutionizes shopping, bridging global markets with a click. From gadgets to groceries, it's the digital marketplace's slick.",
        },
        {
            id: 4,
            Image: "/assests/img/Softwaredevelopment.svg",
            Title: "Software Development ",
            content: "We specializes in software development in all domains & technologies With a dedicated team of experienced developers.",
        },
        {
            id: 5,
            Image: "/assests/img/Softwaredevelopment.svg",
            Title: "Software Development",
            content: "Description of the first reason we give in a simple and understandabe way in this many words"
        },
        {
            id: 6,
            Image: "/assests/img/Support & Maintaince.svg",
            Title: "Support & Maintenance",
            content: "It is necessary one's your platform is live. Our team identify and resolve issues immediately they're reported.",
        },
        {
            id: 7,
            Image: "/assests/img/Webdevelopment.svg",
            Title: "PR & Marketing",
            content: "Elevate your brand's visibility and reputation with our integrated PR & Marketing solutions, designed to captivate audiences and drive impactful results.",
        },
    ]
    return (
        <div className="container ourservices-container py-2 my-2">
            {/* Our goals starts */}
            <div className="row ourgoals-row">
                <div className="ourgoals-fcol col-lg-6 col-md-6 col-sm-12" >
                    <img className="img-fluid" src="/assests/img/goal.gif" alt="logo" />
                </div>
                <div className=" ourgoals-scol col-lg-6 col-md-6 col-sm-12 ">
                    {/* Added "Your goal is Our mission" text here */}
                    <div className="goals-tagline">
                        <span className="goals-eyebrow ">Your <span>goal</span> is Our <span>mission</span> </span>
                    </div>
                    <p>Our team is committed to helping businesses of all sizes reach their objectives.</p>
                    <p> With our creative and development expertise, <b>we work tirelessly to ensure your goals are not only met but exceeded.</b></p>
                </div>
            </div >
            {/* Our goals ends */}

            {/* Our Services starts */}
            <h1 className="ourservices-title text-center">Our Services</h1>
            <div className="container ">
                <div className="row ourservices-row pt-5 gx-5 gy-4">
                    <div className="ourservices-col col-lg-6 col-md-6 col-sm-12 ">
                        <div className="row ourservices-innerrow p-3">
                            <div className="ourservices-img-div  col-lg-2 col-md-2 col-sm-12 p-2">
                                <img className="img-fluid" src="/assests/img/Webdesigning.svg" alt="logo" />
                            </div>
                            <div className="ourservices-col-div col-lg-10 col-md-10 col-sm-12 p-2">
                                <h2>Web Design & Development</h2>
                                <p>Transform your online presence with our expert Web Design & Development solutions, tailored to elevate your brand and engage your audience effectively.</p>
                            </div>
                        </div>
                    </div>
                    <div className="ourservices-col col-lg-6 col-md-6 col-sm-12  " >
                        <div className="row ourservices-innerrow p-3">
                            <div className="ourservices-img-div  col-lg-2 col-md-2 col-sm-12 p-2">
                                <img className="img-fluid" src="/assests/img/Mobiledevelopment.svg" alt="logo" />
                            </div>
                            <div className="ourservices-col-div  col-lg-10  col-md-10 col-sm-12 p-2">
                                <h2>Mobile Application</h2>
                                <p>Smartphone's are being used on a regular basis and most of the users engaged on smart phones. To elevate your business presence.</p>
                            </div>
                        </div>
                    </div >
                    <div className=" ourservices-col col-xxl-6 col-lg-6 col-md-6 col-sm-12 " >
                        <div className="row ourservices-innerrow p-3">
                            <div className="ourservices-img-div  col-lg-2  col-md-2 col-sm-12 p-2">
                                <img className="img-fluid" src="/assests/img/E-Commerce.svg" alt="logo" />
                            </div>
                            <div className="ourservices-col-div col-lg-10 col-md-10 col-sm-12  p-2">
                                <h2>E-Commerce</h2>
                                <p>E-commerce revolutionizes shopping, bridging global markets with a click. From gadgets to groceries, it's the digital marketplace's slick.</p>
                            </div>
                        </div>
                    </div>
                    <div className="ourservices-col  col-lg-6 col-md-6 col-sm-12 " >
                        <div className="row ourservices-innerrow p-3">
                            <div className="ourservices-img-div col-lg-2  col-md-2 col-sm-12  p-2">
                                <img className="img-fluid" src="/assests/img/Softwaredevelopment.svg" alt="logo" />
                            </div>
                            <div className="ourservices-col-div  col-lg-10 col-md-10 col-sm-12  p-2">
                                <h2>Software Development</h2>
                                <p>We specializes in software development in all domains & technologies With a dedicated team of experienced developers.</p>
                            </div>
                        </div>
                    </div>
                    <div className="ourservices-col col-lg-6 col-md-6 col-sm-12 " >
                        <div className="row ourservices-innerrow p-3">
                            <div className="ourservices-img-div  col-lg-2 col-md-2 col-sm-12  p-2" >
                                <img className="img-fluid" src="/assests/img/Webdevelopment.svg" alt="logo" />
                            </div>
                            <div className="ourservices-col-div col-lg-10 col-md-10 col-sm-12  p-2">
                                <h2>PR & Marketing</h2>
                                <p>Elevate your brand's visibility and reputation with our integrated PR & Marketing solutions, designed to captivate audiences and drive impactful results.</p>
                            </div>
                        </div>
                    </div>
                    <div className="ourservices-col  col-lg-6 col-md-6 col-sm-12  " >
                        <div className="row ourservices-innerrow p-3">
                            <div className="ourservices-img-div col-lg-2  col-md-2 col-sm-12  p-2">
                                <img className="img-fluid" src="/assests/img/Support & Maintaince.svg" alt="logo" />
                            </div>
                            <div className="ourservices-col-div  col-lg-10 col-md-10 col-sm-12 p-2">
                                <h2>Support & Maintenance</h2>
                                <p>It is necessary one's your platform is live. Our team identify and resolve issues immediately they're reported.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            {/* Our Services ends */}

            {/* Centered CTA Button for WhatsApp */}
            <div className="text-center my-5">
                <a
                    href="https://wa.me/+918084378326?text=Hello%2C%20I%27m%20interested%20in%20your%20services.%20Could%20you%20please%20provide%20more%20details%3F"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success btn-lg px-4 py-2 fw-semibold shadow"
                    style={{ backgroundColor: "#e2c15b", border: "none", borderRadius: "50px" }}
                >
                     Enquire Now
                </a>
            </div>
        </div >
    );
}

export default OurServices;